import api from './api';

function sanitizeBaseUrl(value) {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  if (!raw) return '';
  try {
    const parsed = new URL(raw);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.origin;
  } catch (_) {}
  return '';
}

const reportsService = {
  async getOverview(params = {}) {
    const query = new URLSearchParams(params).toString();
    return api.get(`/api/reports/overview${query ? `?${query}` : ''}`);
  },
  async getAudit(params = {}) {
    const query = new URLSearchParams(params).toString();
    return api.get(`/api/reports/audit${query ? `?${query}` : ''}`);
  },
  async exportAuditCsv(params = {}) {
    const query = new URLSearchParams(params).toString();
    const base = sanitizeBaseUrl(localStorage.getItem('apiBaseUrl'))
      || sanitizeBaseUrl(process.env.REACT_APP_API_URL)
      || sanitizeBaseUrl(window.location.origin);
    const userData = localStorage.getItem('vortiqaUser');
    const token = userData ? JSON.parse(userData).token : null;
    const resp = await fetch(`${base}/api/reports/audit.csv${query ? `?${query}` : ''}`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      throw new Error(text || `Erro HTTP ${resp.status}`);
    }
    return resp.blob();
  },
  async exportPausesCsv(params = {}) {
    const query = new URLSearchParams(params).toString();
    const base = sanitizeBaseUrl(localStorage.getItem('apiBaseUrl'))
      || sanitizeBaseUrl(process.env.REACT_APP_API_URL)
      || sanitizeBaseUrl(window.location.origin);
    const userData = localStorage.getItem('vortiqaUser');
    const token = userData ? JSON.parse(userData).token : null;
    const resp = await fetch(`${base}/api/reports/pauses.csv${query ? `?${query}` : ''}`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      throw new Error(text || `Erro HTTP ${resp.status}`);
    }
    return resp.blob();
  }
};

export default reportsService;
